module.exports = __webpack_public_path__ + "img/four.64ec401e.png";